module.exports = __webpack_public_path__ + "img/box_pro_four_5.f3fecb12.jpg";